import { render, staticRenderFns } from "./LawMatterSubSubjectTableForm.vue?vue&type=template&id=4e6bfb64&"
import script from "./LawMatterSubSubjectTableForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterSubSubjectTableForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterSubSubjectTableForm.vue?vue&type=style&index=0&id=4e6bfb64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports